(function (global, factory) {
    typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports, require('@angular/core'), require('@shraddhar/web/menu-surface'), require('@angular/cdk/coercion'), require('rxjs'), require('rxjs/operators'), require('@shraddhar/web/list'), require('@shraddhar/web/dom'), require('@material/menu')) :
    typeof define === 'function' && define.amd ? define('@shraddhar/web/menu', ['exports', '@angular/core', '@shraddhar/web/menu-surface', '@angular/cdk/coercion', 'rxjs', 'rxjs/operators', '@shraddhar/web/list', '@shraddhar/web/dom', '@material/menu'], factory) :
    (global = global || self, factory((global.shraddhar = global.shraddhar || {}, global.shraddhar.web = global.shraddhar.web || {}, global.shraddhar.web.menu = {}), global.ng.core, global.ng.web.menuSurface, global.ng.cdk.coercion, global.rxjs, global.rxjs.operators, global.ng.web.list, global.ng.web.dom, global.mdc.menu));
}(this, (function (exports, core, menuSurface, coercion, rxjs, operators, list, dom, menu) { 'use strict';

    /*! *****************************************************************************
    Copyright (c) Microsoft Corporation. All rights reserved.
    Licensed under the Apache License, Version 2.0 (the "License"); you may not use
    this file except in compliance with the License. You may obtain a copy of the
    License at http://www.apache.org/licenses/LICENSE-2.0

    THIS CODE IS PROVIDED ON AN *AS IS* BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY
    KIND, EITHER EXPRESS OR IMPLIED, INCLUDING WITHOUT LIMITATION ANY IMPLIED
    WARRANTIES OR CONDITIONS OF TITLE, FITNESS FOR A PARTICULAR PURPOSE,
    MERCHANTABLITY OR NON-INFRINGEMENT.

    See the Apache Version 2.0 License for specific language governing permissions
    and limitations under the License.
    ***************************************************************************** */
    /* global Reflect, Promise */

    var extendStatics = function(d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };

    function __extends(d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    }

    var __assign = function() {
        __assign = Object.assign || function __assign(t) {
            for (var s, i = 1, n = arguments.length; i < n; i++) {
                s = arguments[i];
                for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
            }
            return t;
        };
        return __assign.apply(this, arguments);
    };

    function __rest(s, e) {
        var t = {};
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
        if (s != null && typeof Object.getOwnPropertySymbols === "function")
            for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
                if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                    t[p[i]] = s[p[i]];
            }
        return t;
    }

    function __decorate(decorators, target, key, desc) {
        var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
        if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
        else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
        return c > 3 && r && Object.defineProperty(target, key, r), r;
    }

    function __param(paramIndex, decorator) {
        return function (target, key) { decorator(target, key, paramIndex); }
    }

    function __metadata(metadataKey, metadataValue) {
        if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
    }

    function __awaiter(thisArg, _arguments, P, generator) {
        function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
        return new (P || (P = Promise))(function (resolve, reject) {
            function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
            function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
            function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
            step((generator = generator.apply(thisArg, _arguments || [])).next());
        });
    }

    function __generator(thisArg, body) {
        var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
        return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
        function verb(n) { return function (v) { return step([n, v]); }; }
        function step(op) {
            if (f) throw new TypeError("Generator is already executing.");
            while (_) try {
                if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
                if (y = 0, t) op = [op[0] & 2, t.value];
                switch (op[0]) {
                    case 0: case 1: t = op; break;
                    case 4: _.label++; return { value: op[1], done: false };
                    case 5: _.label++; y = op[1]; op = [0]; continue;
                    case 7: op = _.ops.pop(); _.trys.pop(); continue;
                    default:
                        if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                        if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                        if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                        if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                        if (t[2]) _.ops.pop();
                        _.trys.pop(); continue;
                }
                op = body.call(thisArg, _);
            } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
            if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
        }
    }

    function __exportStar(m, exports) {
        for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
    }

    function __values(o) {
        var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
        if (m) return m.call(o);
        if (o && typeof o.length === "number") return {
            next: function () {
                if (o && i >= o.length) o = void 0;
                return { value: o && o[i++], done: !o };
            }
        };
        throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
    }

    function __read(o, n) {
        var m = typeof Symbol === "function" && o[Symbol.iterator];
        if (!m) return o;
        var i = m.call(o), r, ar = [], e;
        try {
            while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
        }
        catch (error) { e = { error: error }; }
        finally {
            try {
                if (r && !r.done && (m = i["return"])) m.call(i);
            }
            finally { if (e) throw e.error; }
        }
        return ar;
    }

    function __spread() {
        for (var ar = [], i = 0; i < arguments.length; i++)
            ar = ar.concat(__read(arguments[i]));
        return ar;
    }

    function __spreadArrays() {
        for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
        for (var r = Array(s), k = 0, i = 0; i < il; i++)
            for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
                r[k] = a[j];
        return r;
    };

    function __await(v) {
        return this instanceof __await ? (this.v = v, this) : new __await(v);
    }

    function __asyncGenerator(thisArg, _arguments, generator) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var g = generator.apply(thisArg, _arguments || []), i, q = [];
        return i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i;
        function verb(n) { if (g[n]) i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; }
        function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
        function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
        function fulfill(value) { resume("next", value); }
        function reject(value) { resume("throw", value); }
        function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
    }

    function __asyncDelegator(o) {
        var i, p;
        return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
        function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: n === "return" } : f ? f(v) : v; } : f; }
    }

    function __asyncValues(o) {
        if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
        var m = o[Symbol.asyncIterator], i;
        return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
        function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
        function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
    }

    function __makeTemplateObject(cooked, raw) {
        if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
        return cooked;
    };

    function __importStar(mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
        result.default = mod;
        return result;
    }

    function __importDefault(mod) {
        return (mod && mod.__esModule) ? mod : { default: mod };
    }

    function __classPrivateFieldGet(receiver, privateMap) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to get private field on non-instance");
        }
        return privateMap.get(receiver);
    }

    function __classPrivateFieldSet(receiver, privateMap, value) {
        if (!privateMap.has(receiver)) {
            throw new TypeError("attempted to set private field on non-instance");
        }
        privateMap.set(receiver, value);
        return value;
    }

    var MdcMenuSelectedEvent = /** @class */ (function () {
        function MdcMenuSelectedEvent(index, source) {
            this.index = index;
            this.source = source;
        }
        return MdcMenuSelectedEvent;
    }());
    var nextUniqueId = 0;
    var MdcMenu = /** @class */ (function (_super) {
        __extends(MdcMenu, _super);
        function MdcMenu() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            /** Emits whenever the component is destroyed. */
            _this._destroyed = new rxjs.Subject();
            _this._uniqueId = menu.cssClasses.ROOT + "-" + ++nextUniqueId;
            _this.id = _this._uniqueId;
            _this._wrapFocus = false;
            _this._closeSurfaceOnSelection = true;
            _this.selected = new core.EventEmitter();
            _this._menuFoundation = new menu.MDCMenuFoundation(_this._createAdapter());
            return _this;
        }
        Object.defineProperty(MdcMenu.prototype, "wrapFocus", {
            get: function () {
                return this._wrapFocus;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._wrapFocus) {
                    this._wrapFocus = newValue;
                    this._list.wrapFocus = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcMenu.prototype, "closeSurfaceOnSelection", {
            get: function () {
                return this._closeSurfaceOnSelection;
            },
            set: function (value) {
                var newValue = coercion.coerceBooleanProperty(value);
                if (newValue !== this._closeSurfaceOnSelection) {
                    this._closeSurfaceOnSelection = newValue;
                }
            },
            enumerable: true,
            configurable: true
        });
        Object.defineProperty(MdcMenu.prototype, "defaultFocusState", {
            get: function () {
                return this._defaultFocusState;
            },
            set: function (value) {
                if (value !== this._defaultFocusState) {
                    this._defaultFocusState = coercion.coerceNumberProperty(value, 0);
                    this._menuFoundation.setDefaultFocusState(this._defaultFocusState);
                }
            },
            enumerable: true,
            configurable: true
        });
        MdcMenu.prototype._createAdapter = function () {
            var _this = this;
            return Object.assign({
                addClassToElementAtIndex: function (index, className) {
                    return _this._list.items.toArray()[index].getListItemElement().classList.add(className);
                },
                removeClassFromElementAtIndex: function (index, className) {
                    return _this._list.items.toArray()[index].getListItemElement().classList.remove(className);
                },
                addAttributeToElementAtIndex: function (index, attr, value) {
                    return _this._list.items.toArray()[index].getListItemElement().setAttribute(attr, value);
                },
                removeAttributeFromElementAtIndex: function (index, attr) {
                    return _this._list.items.toArray()[index].getListItemElement().removeAttribute(attr);
                },
                elementContainsClass: function (element, className) { return element.classList.contains(className); },
                closeSurface: function (skipRestoreFocus) {
                    if (_this.closeSurfaceOnSelection) {
                        _this._foundation.close(skipRestoreFocus);
                    }
                },
                getElementIndex: function (element) {
                    return _this._list.items.toArray().findIndex(function (_) { return _.getListItemElement() === element; });
                },
                notifySelected: function (evtData) {
                    return _this.selected.emit(new MdcMenuSelectedEvent(evtData.index, _this._list.items.toArray()[evtData.index]));
                },
                getMenuItemCount: function () { return _this._list.items.toArray().length; },
                focusItemAtIndex: function (index) { return _this._list.items.toArray()[index].focus(); },
                focusListRoot: function () { return _this._list.focus(); },
                isSelectableItemAtIndex: function (index) {
                    return !!dom.closest(_this._list.items.toArray()[index].getListItemElement(), "." + menu.cssClasses.MENU_SELECTION_GROUP);
                },
                getSelectedSiblingOfItemAtIndex: function (index) {
                    var selectionGroupEl = dom.closest(_this._list.items.toArray()[index].getListItemElement(), "." + menu.cssClasses.MENU_SELECTION_GROUP);
                    var selectedItemEl = selectionGroupEl.querySelector("." + menu.cssClasses.MENU_SELECTED_LIST_ITEM);
                    return selectedItemEl ? _this._list.items.toArray().findIndex(function (_) {
                        return _.elementRef.nativeElement === selectedItemEl;
                    }) : -1;
                }
            });
        };
        MdcMenu.prototype.ngAfterContentInit = function () {
            var _this = this;
            this.initMenuSurface();
            this._initList();
            this.opened.pipe(operators.takeUntil(this._destroyed))
                .subscribe(function () { return _this._menuFoundation.handleMenuSurfaceOpened(); });
        };
        MdcMenu.prototype.ngOnDestroy = function () {
            this._destroyed.next();
            this._destroyed.complete();
            this.destroyMenuSurface();
            this._menuFoundation.destroy();
        };
        MdcMenu.prototype._handleKeydown = function (evt) {
            this._menuFoundation.handleKeydown(evt);
        };
        MdcMenu.prototype._initList = function () {
            var _this = this;
            if (!this._list) {
                return;
            }
            this._list.setRole('menu');
            this._list.wrapFocus = this._wrapFocus;
            this._list.setTabIndex(-1);
            // When the list items change, re-subscribe
            this._list.items.changes.pipe(operators.takeUntil(this._destroyed))
                .subscribe(function () { return _this._list.items.forEach(function (item) { return item.setRole('menuitem'); }); });
            this._list.actionEvent.pipe(operators.takeUntil(this._destroyed))
                .subscribe(function (event) {
                return _this._menuFoundation.handleItemAction(_this._list.items.toArray()[event.index].getListItemElement());
            });
        };
        MdcMenu.decorators = [
            { type: core.Component, args: [{
                        selector: 'mdc-menu',
                        exportAs: 'mdcMenu',
                        host: {
                            '[id]': 'id',
                            'class': 'mdc-menu mdc-menu-surface',
                            '(keydown)': '_handleKeydown($event)',
                        },
                        template: '<ng-content></ng-content>',
                        encapsulation: core.ViewEncapsulation.None,
                        changeDetection: core.ChangeDetectionStrategy.OnPush
                    }] }
        ];
        MdcMenu.propDecorators = {
            id: [{ type: core.Input }],
            wrapFocus: [{ type: core.Input }],
            closeSurfaceOnSelection: [{ type: core.Input }],
            defaultFocusState: [{ type: core.Input }],
            selected: [{ type: core.Output }],
            _list: [{ type: core.ContentChild, args: [list.MdcList, { static: false },] }]
        };
        return MdcMenu;
    }(menuSurface.MdcMenuSurfaceBase));

    var MdcMenuSelectionGroup = /** @class */ (function () {
        function MdcMenuSelectionGroup(elementRef) {
            this.elementRef = elementRef;
        }
        MdcMenuSelectionGroup.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcMenuSelectionGroup], mdc-menu-selection-group',
                        host: { 'class': 'mdc-menu__selection-group' },
                        exportAs: 'mdcMenuSelectionGroup'
                    },] }
        ];
        /** @nocollapse */
        MdcMenuSelectionGroup.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcMenuSelectionGroup;
    }());
    var MdcMenuSelectionGroupIcon = /** @class */ (function () {
        function MdcMenuSelectionGroupIcon(elementRef) {
            this.elementRef = elementRef;
        }
        MdcMenuSelectionGroupIcon.decorators = [
            { type: core.Directive, args: [{
                        selector: '[mdcMenuSelectionGroupIcon], mdc-menu-selection-group-icon',
                        host: { 'class': 'mdc-menu__selection-group-icon' },
                        exportAs: 'mdcMenuSelectionGroupIcon'
                    },] }
        ];
        /** @nocollapse */
        MdcMenuSelectionGroupIcon.ctorParameters = function () { return [
            { type: core.ElementRef }
        ]; };
        return MdcMenuSelectionGroupIcon;
    }());

    var MENU_DECLARATIONS = [
        MdcMenu,
        MdcMenuSelectionGroup,
        MdcMenuSelectionGroupIcon
    ];
    var MdcMenuModule = /** @class */ (function () {
        function MdcMenuModule() {
        }
        MdcMenuModule.decorators = [
            { type: core.NgModule, args: [{
                        imports: [menuSurface.MdcMenuSurfaceModule],
                        exports: __spread(MENU_DECLARATIONS, [
                            menuSurface.MdcMenuSurfaceModule
                        ]),
                        declarations: [MENU_DECLARATIONS]
                    },] }
        ];
        return MdcMenuModule;
    }());

    /**
     * Generated bundle index. Do not edit.
     */

    exports.MdcMenu = MdcMenu;
    exports.MdcMenuModule = MdcMenuModule;
    exports.MdcMenuSelectedEvent = MdcMenuSelectedEvent;
    exports.MdcMenuSelectionGroup = MdcMenuSelectionGroup;
    exports.MdcMenuSelectionGroupIcon = MdcMenuSelectionGroupIcon;

    Object.defineProperty(exports, '__esModule', { value: true });

})));
//# sourceMappingURL=web-menu.umd.js.map
